import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';
import { useApiQuery } from '../../../../../api/hooks';
import apiClient from '../../../../../api/apiClient';
import { usePreloaderStore } from '../../../../../stores';
import { PlusIcon, CheckIcon, EditPencilIcon, TrashIcon } from '../../../model/icons';
import Modal from '../../controls/Modal';
import LabeledInput from '../../controls/LabeledInput';

// Панель «Основная»: курс конвертации монет по дням.
export default function MainPanel({ neighbor }) {
    const { data: courses, refetch } = useApiQuery(
        ['neighbor', 'coin-courses', neighbor.id],
        `/api/neighbor/admin/coin-courses/list-by-neighbor?neighborId=${neighbor.id}`,
        { refetchOnMount: 'always' }
    );
    const [addOpen, setAddOpen] = useState(false);
    const sorted = [...(courses || [])].sort((a, b) => new Date(a.date) - new Date(b.date));

    return (
        <div className="bt-panel">
            <div className="sp-secthead">
                <h2>Курс конвертации по дням</h2>
                <button type="button" className="btn btn-primary btn-sm" onClick={() => setAddOpen(true)}>
                    <span className="ic"><PlusIcon /></span>Добавить
                </button>
            </div>
            <div className="fr-sub" style={{ marginBottom: 14 }}>1 SOL = курс × валюта дня</div>
            {sorted.length > 0 ? (
                <div className="sp-course">
                    {sorted.map(course => <CourseRow key={course.id} course={course} refetch={refetch} />)}
                </div>
            ) : <div className="bt-empty">Нет данных о курсе</div>}

            {addOpen && <CourseModal neighborId={neighbor.id} onSuccess={refetch} onClose={() => setAddOpen(false)} />}
        </div>
    );
}

MainPanel.propTypes = { neighbor: PropTypes.object.isRequired };

function CourseRow({ course, refetch }) {
    const { enqueueSnackbar } = useSnackbar();
    const { show, hide } = usePreloaderStore();
    const [editing, setEditing] = useState(false);
    const [val, setVal] = useState(String(course.course));

    const save = async () => {
        show();
        try {
            await apiClient.patch(`/api/neighbor/admin/coin-courses/update?id=${course.id}`, { course: parseFloat(val) });
            enqueueSnackbar('Курс обновлён', { variant: 'success' });
            setEditing(false);
            refetch();
        } catch (e) { enqueueSnackbar('Ошибка при обновлении курса', { variant: 'error' }); }
        finally { hide(); }
    };

    const del = async () => {
        show();
        try {
            await apiClient.delete(`/api/neighbor/admin/coin-courses/delete?id=${course.id}`);
            enqueueSnackbar('Курс удалён', { variant: 'success' });
            refetch();
        } catch (e) { enqueueSnackbar('Ошибка при удалении курса', { variant: 'error' }); }
        finally { hide(); }
    };

    return (
        <div className="sp-crow">
            <span className="sp-cdate">{course.date}</span>
            {editing ? (
                <>
                    <span className="sp-cval"><input type="number" step="0.1" value={val} onChange={(e) => setVal(e.target.value)} /></span>
                    <button type="button" className="sp-cact ed" onClick={save} title="Сохранить"><CheckIcon /></button>
                </>
            ) : (
                <>
                    <span className="sp-cval">{course.course}</span>
                    <button type="button" className="sp-cact ed" onClick={() => { setVal(String(course.course)); setEditing(true); }} title="Изменить"><EditPencilIcon /></button>
                </>
            )}
            <button type="button" className="sp-cact del" onClick={del} title="Удалить"><TrashIcon /></button>
        </div>
    );
}

CourseRow.propTypes = {
    course: PropTypes.shape({ id: PropTypes.number, date: PropTypes.string, course: PropTypes.number }).isRequired,
    refetch: PropTypes.func.isRequired
};

function CourseModal({ neighborId, onSuccess, onClose }) {
    const { enqueueSnackbar } = useSnackbar();
    const { show, hide } = usePreloaderStore();
    const [date, setDate] = useState('');
    const [course, setCourse] = useState('1');

    const submit = async () => {
        if (!date) return;
        show();
        try {
            await apiClient.post('/api/neighbor/admin/coin-courses/create', { neighborId, date, course: parseFloat(course) });
            enqueueSnackbar('Курс создан', { variant: 'success' });
            onSuccess();
            onClose();
        } catch (e) { enqueueSnackbar(e.response?.data?.message || 'Ошибка при создании', { variant: 'error' }); }
        finally { hide(); }
    };

    return (
        <Modal
            open
            kicker="Курс"
            title="Добавить курс"
            size="sm"
            onClose={onClose}
            footer={(
                <>
                    <button type="button" className="btn btn-ghost" onClick={onClose}>Отмена</button>
                    <button type="button" className="btn btn-primary" onClick={submit} disabled={!date}>Создать</button>
                </>
            )}
        >
            <LabeledInput label="Дата" type="date" value={date} onChange={(e) => setDate(e.target.value)} />
            <LabeledInput label="Курс конвертации" type="number" value={course} onChange={(e) => setCourse(e.target.value)} />
        </Modal>
    );
}

CourseModal.propTypes = {
    neighborId: PropTypes.number.isRequired,
    onSuccess: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
};
